module.exports = __webpack_public_path__ + "img/4+.a4dd9e8f.png";